export default __webpack_public_path__ + "static/media/Icons_arrow_right-circle.164a428f.svg";